jQuery(document).ready(function() {
  var tables = jQuery('.node__content table');
  tables.each(function() {
    jQuery(this).flextable({
      debug: true,
      bt: 'window',
      bw: 991,
      cm: 'load',
      // hparent: '',
      // hcell: '',
      // header: 'before',
      combine: true
    });
  });
});


// var rtime;
// var timeout = false;
// var delta = 200;
// jQuery(window).resize(function() {
//   rtime = new Date();
//   if (timeout === false) {
//     timeout = true;
//     setTimeout(resizeend, delta);
//   }
// });
//
// function resizeend() {
//   if (new Date() - rtime < delta) {
//     setTimeout(resizeend, delta);
//   } else {
//     timeout = false;
//     alert('Done resizing');
//   }
// }